import { UnreachableError } from 'utils/errors';
import { PageSize, PageSizeString } from 'types/state';

export const normalizePageSize = (value: PageSize) => ({
  toPageSizeString(): PageSizeString {
    switch (value) {
      case 20:
        return '20';
      case 50:
        return '50';
      case 100:
        return '100';
      default:
        throw new UnreachableError(value);
    }
  },
});

export const normalizePageSizeString = (value: PageSizeString) => ({
  toPageSize(): PageSize {
    switch (value) {
      case '20':
        return 20;
      case '50':
        return 50;
      case '100':
        return 100;
      default:
        throw new UnreachableError(value);
    }
  },
});
